export const MCP_OAUTH_CHANNEL = "rakazo-mcp-oauth";
